import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import { minimumAllowedNumberOfTacticsInGroup } from '../TacticForm.constants';
import GroupDialogFormConfig from './GroupDialogFormConfig';
import { SelectOption } from 'basics/options/options.types';
import { TacticStateType, CepStateType } from 'basics/types/maya.types';
import cepState from 'states/cep.states';
import tacticState from 'states/tactic.states';
import { useYodaCreateForm } from 'yoda-ui/yodaForm/hooks/useYodaCreateForm';

const useGroupDialog = (
  openDefaultValue: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  submitAction: Function,
) => {
  const cepStateValue = useSnapshot(cepState) as CepStateType;
  const tacticStateValue = useSnapshot(tacticState) as TacticStateType;
  const cepId = cepStateValue.cep?._id || null;
  const [loading, setLoading] = useState(false);

  const {
    providerFields,
    useWatchField,
  } = useYodaCreateForm();

  const selectedTactics: SelectOption[] = useWatchField('tacticsInGroup')?.value;
  const [isAllowedGroupCreation, setIsAllowedGroupCreation] = useState(false);

  const handleFormSubmit: React.MouseEventHandler<HTMLButtonElement> = async () => {
    setLoading(true);
    const selectedTacticsId = selectedTactics.map((tacticId: SelectOption) => tacticId);
    await submitAction(selectedTacticsId);
    setOpen(false);
    setLoading(false);
  };

  useEffect(() => {
    const allowingStatus = selectedTactics?.length >= minimumAllowedNumberOfTacticsInGroup;
    if (allowingStatus !== isAllowedGroupCreation) {
      setIsAllowedGroupCreation(allowingStatus);
    }
  }, [selectedTactics, isAllowedGroupCreation]);

  const groupDialogFormConfig = GroupDialogFormConfig(
    openDefaultValue,
    setOpen,
    cepId,
    tacticStateValue,
    handleFormSubmit,
    isAllowedGroupCreation,
  );

  return {
    groupDialogFormConfig,
    setOpen,
    providerFields,
    loading,
  };
};

export default useGroupDialog;
